<template>
  <div>
    <v-btn color="green" @click="dialog=!dialog">
      <v-icon>add</v-icon>
    </v-btn>

    <v-dialog
        max-width="490"
        v-model="dialog"
    >
      <v-card>
        <v-card-title class="headline">{{ $t('calendar.schema.adding_new_template') }}</v-card-title>
        <v-card-text>
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">info</v-icon>
            </template>
            <span>Jeśli chcesz użyć wartości z pola formularza, użyj szablonu {f'nr_pola'} np. {f2} dla pola numer 2</span>
          </v-tooltip>
          <CalendarData v-on:updated="createData=$event.data"/>
        </v-card-text>
        <v-card-actions>
          <v-btn
              @click="createTemplate()"
              color="green darken-1"
              text
          >
            {{ $t('calendar.create.create') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
              @click="dialog = false"
              color="red darken-1"
              text
          >
            {{ $t('calendar.base.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-data-table
        :headers="headers"
        :items="calendarTemplates"
        class="elevation-1"
        hide-actions
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.name_template }}</td>
        <td class="text-xs">{{ props.item.description_template }}</td>
        <td class="text-xs">{{ props.item.date_template }}</td>
        <td class="text-xs">{{ props.item.time_template }}</td>
        <td class="text-xs">{{ props.item.end_date_template }}</td>
        <td class="text-xs">{{ props.item.end_time_template }}</td>
        <td class="text-xs">{{ props.item.default_duration > 0 ? props.item.default_duration / 60 : 0 }}</td>
        <td class="text-xs">{{ props.item.user_template }}</td>
        <td class="text-xs">{{ props.item.user_field }}</td>
        <td class="text-xs">{{ props.item.color }}</td>
        <td class="text-xs">{{ getDependText(props.item.depend) }}</td>
        <td class="justify-center layout px-0">
          <v-btn @click="deleteTemplate(props.item.id)" class="mx-0" icon>
            <v-icon color="black">delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="no-data">
        <span>{{ $t('calendar.base.no_data') }}</span>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import Messenger from "@/plugins/Messenger"
import CalendarData from "./CalendarData"

export default {
  name: "schema",
  components: {CalendarData},
  data() {
    return {
      dialog: false,
      calendarTemplates: [],
      createData: {}
    }
  },
  computed: {
    headers() {
      return [
        {text: 'id', align: 'left', sortable: false, value: 'id'},
        {text: this.$t('calendar.schema.event_name_template'), value: 'name_template'},
        {text: this.$t('calendar.schema.event_description_template'), value: 'description_template'},
        {text: this.$t('calendar.schema.event_date_template'), value: 'date_template'},
        {text: this.$t('calendar.schema.event_hour_template'), value: 'time_template'},
        {text: 'Data zakończenia', value: 'end_date_template'},
        {text: 'Godzina zakończenia', value: 'end_time_template'},
        {text: 'Domyslny czas trwania', value: 'default_duration'},
        {text: 'Pola z użytkownikiem', value: 'eventUserTemplate'},
        {text: 'Własciwość użytkownika', value: 'eventUserField'},
        {text: this.$t('calendar.base.color'), value: 'color'},
        {text: 'Kolory zależne', value: 'depend'},
      ]
    }
  },
  created() {
    this.$http.get('calendar-schema/schema/' + this.$route.params.schemaId).then(data => {
      this.calendarTemplates = data.data
    }).catch(() => Messenger.emitError(this.$t('calendar.schema.error.cannot_download')))
  },
  methods: {
    getDependText(depend) {
      if (!depend) {
        return ""
      }

      let returnText = ""
      returnText = "Szablon pola zależnego: " + depend.depend_field_template
      returnText += "\n " + depend.depend_colors.map(el => "\nWartość zależna oraz kolor: " + el.depend + " (" + el.color + ")").join("\n")
      return returnText
    },
    createTemplate() {
      let payload = this.createData
      if (!this.validate()) {
        return
      }
      payload.schema_id = this.$route.params.schemaId

      this.$http.post('calendar-schema', payload).then((data) => {
        this.calendarTemplates.push(data.data)
        this.dialog = false
      }).catch(() => Messenger.emitError(this.$t('calendar.schema.error.cannot_add')))
    },
    validate() {
      if (!this.createData.name_template || this.createData.name_template.length < 3) {
        Messenger.emitError(this.$t('calendar.schema.error.name_template'))
        return false
      }
      if (this.createData.date_template.length < 4) {
        Messenger.emitError(this.$t('calendar.schema.error.date_template'))
        return false
      }
      if (this.createData.time_template.length < 3) {
        Messenger.emitError(this.$t('calendar.schema.error.time_template'))
        return false
      }
      if (this.createData.color.length < 3) {
        Messenger.emitError(this.$t('calendar.schema.error.color'))
        return false
      }

      return true
    },
    deleteTemplate(id) {
      return this.$confirm(this.$t('calendar.schema.sure_delete')).then(res => {
        if (res) {
          this.$http.delete(`calendar-schema/${id}`).then(() => {
            this.calendarTemplates = this.calendarTemplates.filter(el => el.id != id)
          }).catch(() => {
            Messenger.emitError(this.$t('calendar.schema.cannot_delete'))
          })
        }
      })

    }
  },

}
</script>

<style scoped>

</style>